import packageJson from '../../../package.json';

export const getAppPath = (): string => {
  return `${window.location.origin}${packageJson.publicPath}`;
};

export const allowedACRs = {
  al1: 'https://id.storebrand.no/authn/al1',
  al2: 'https://id.storebrand.no/authn/al2',
  al3: 'https://id.storebrand.no/authn/al3',
  al4: 'https://id.storebrand.no/authn/al4',
} as const;
